var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-sm"},[(_vm.label)?_c('div',{staticClass:"mb-1 text-sm text-gray-700",domProps:{"innerHTML":_vm._s(_vm.label)}}):_vm._e(),_c('div',{staticClass:"font-medium"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }